// extracted by mini-css-extract-plugin
export default {"favouritesTitle":"style-module--favouritesTitle--9ae16","favouritesCard":"style-module--favouritesCard--fada4"};